import { Hero } from "@/components/home/Hero";
import { Marquee } from "@/components/home/Marquee";
import { Intro } from "@/components/home/Intro";
import { Timeline } from "@/components/home/Timeline";
import { Equipment } from "@/components/home/Equipment";
import { Pricing } from "@/components/home/Pricing";
import { Upsell } from "@/components/home/Upsell";
import { WhyThree } from "@/components/home/WhyThree";
import { Delivery } from "@/components/home/Delivery";
import { Gallery } from "@/components/home/Gallery";
import { Markets } from "@/components/home/Markets";
import { Calculator } from "@/components/home/Calculator";
import { DocsTeaser } from "@/components/home/DocsTeaser";
import { FaqTeaser, FinalCta } from "@/components/home/FaqTeaser";
import { DualGateway } from "@/components/home/DualGateway";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <DualGateway />
      <Marquee />
      <Intro />
      <Timeline />
      <Equipment />
      <Pricing />
      <Upsell />
      <WhyThree />
      <Delivery />
      <Gallery />
      <Markets />
      <Calculator />
      <DocsTeaser />
      <FaqTeaser />
      <FinalCta />
    </div>
  );
}
